import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FsLightbox from "fslightbox-react";
import { Banner } from "../../components/Banner/Banner";
import {
  bloginnerban,
  facebook,
  gallery1,
  leftarrow,
  mainimg,
  moreblog1,
  moreblog2,
  moreblog3,
  coloredArrow,
  playicon,
  whatsapp,
  linkedinblog,
  twitterblog,
  copy,
  mainimgmob,
  bannerInner3,
} from "../../images";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";

import "./BlogInner3.scss";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const BlogInner = () => {
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const blogDateArr = [
    {
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      company: "Sanathan",
    },
  ];

  const blogDescArr = [
    {
      id: 1,
      heading: "What Are Some Examples Of Technical Textiles?",
      desc1:
        "Technical textiles in India are a vital component of modern life. These materials are employed in a wide range of industries, from medical gadgets to athletic products. This article will provide an overview of technical textiles, their examples and how it is used nowadays.<br/><br/>First, Let’s understand what is Technical Textile? <br/><br/><strong> What Are Technical Textiles?</strong><br/> <br/>Technical textiles, also known as smart textiles are textile components and products with technical traits and characteristics. It is a textile product manufactured for non-aesthetic purposes, where the function is the primary criterion. They are created from natural and man-made fibres such as Nomex, Kevlar, Spandex, and Twaron, which have better functional features such as higher tenacity, excellent insulation, improved thermal resistance, and so on.<br/><br/> Technical textiles are a promising position in the textile industry. It is employed for the proper application of its functional features and the production of diverse applications. <br/><br/><strong>9 Technical Textiles Examples:</strong><br/>  <br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>1. Agrotextiles (Agro-Textiles)</strong><br/>Technical textile applications in agriculture cover all tasks related to the cultivation and harvesting of crops and animals. The primary role of most agricultural textiles is to protect food, animals, or land. Crop production, forestry and horticulture, livestock and poultry husbandry, and fishing are all examples of end uses. The fishing industry consumes a lot of textile materials. Fishing practices are becoming increasingly industrialized, with small net and line fishing techniques being phased out.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 2. Geotextiles (Geo-Textiles)</strong><br/> Geotextiles are all woven, nonwoven, and knitted textile materials used primarily by the civil engineering sector to provide support, drainage, and isolation at or below ground level. Geotextiles are used in a variety of applications, including building, bridge, dam, road, railway, and path construction, as well as embankments, cuttings, dykes, and sub- sea coastal engineering projects. These are increasingly being used for waste containment in hazardous waste disposal sites and industrial and municipal effluent treatment facilities.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 3. Hometech (Domestic Textiles)</strong><br/> Hometech is the fourth-largest seller of technical textiles in the world. Hometech products contain both synthetic and natural fibres. Western countries account for the biggest market share of hometech textiles followed by the Asia Pacific region. Hometech textiles are majorly used in furniture &amp; interior decoration, sun protection, cushion materials, carpeting, fireproofing, wall coverings, flooring and textile reinforced fittings etc. The hometech textiles market is supposed to observe a great increase of 4.8% CAGR year on year.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>4. Indutech (Industrial Textiles)</strong><br/> Indutech refers to textiles used in several industrial applications. There is increasing demand from uses like cleansing, conveyancing industrial instrumentation, agriculture and farming, environmental protection, sport and leisure, unit furnishing and coverings, and packaging. Technical textiles are proving their worth in yet another field, contributing to the advancement of industrial and technological growth. Technical textiles include mechanical and textile engineering goods and solutions. Indutech Textiles Market size is growing at a moderate pace with substantial growth rates over the last few years. It estimated that the market will grow significantly in the period from 2021 to 2028.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>5. Medtech (Medical Textiles) </strong><br/>The word MedTech refers to technical textiles used in the medical and rehabilitation industries. It entails the development, processing, and application of safe and sanitary products. Medical textiles from the MedTech sector help patients get the best care possible. Because of their high process dependability requirements, MedTech products are among the most advanced technical textiles. Textiles materials that are used in medical applications include fibres, yarns, fabrics and composites. Depending upon the application, the major requirements of medical textiles are absorbency, tenacity, flexibility, softness and at times biostability or biodegradability.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 6. Mobiltech (Textiles Used In Transport)</strong><br/> Mobiltech textiles are utilised in the automotive and transportation industries. It&#39;s some sort of technological fabric. Some of the uses are automobiles, automotive components, aircraft and railways. Mobiltech is concerned with more than just isolation and safety; it is also concerned with comfort and aesthetics. Mobiltech is used in seatbelt webbing, car upholstery, airbags, helmets and tyre cords. Materials like nylon, polyester and polyester blends are used extensively in mobiltech.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>7. Ecotech (Eco-Friendly Textiles) </strong><br/>Oekotech or Ecotech is a textile application in environmental protection. It includes floor sealants, erosion protection, air cleaning, water pollution prevention, water cleaning, waste treatment/recycling, depositing area construction, product extraction, and household water sewerage plant. The key component in this is landfill waste management and the secondary protection is the chemical/oil industries. <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>8. Protech (Protective Textiles)</strong><br/>Protective textile is a type of technical cloth that has exceptional protective properties to protect against a wide range of natural and man-made threats. It occasionally has smart e-textile features like chemical, heat and cold protection, and so on are all examples of protective functioning. Protective textiles has important use cases in frie suits, chemical clothing, biological suits, and ballistic vests. In most cases we can find it in bullet proof vests as well as space suits.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 9. SportTech (Sports Textiles)</strong><br/> Sports textiles, also known as Sporttex, are primarily utilised in the production of sportswear, such as sports shoes and other sports equipment. The growing popularity of active sports and outdoor leisure activities such as flying, sailing, climbing, and cycling has resulted in a massive increase in the use of textile materials in the production of sporting and related items and equipment. In the production of athletic textiles, synthetic fibres and coatings have essentially supplanted conventional cotton fabrics and other natural fibres.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 10. Clothtech (Clothing Textiles)</strong> <br/>Clothtech is a technical textile subset that includes all textile materials used in garments, footwear, laces, interlinings, zip fasteners, elastic narrow fabrics (tapes), Velcro, labels, umbrella cloth, and sewing threads. Technical textiles for clothing, particularly in the finishing process, where the fabric is handled under high pressure and high temperatures, support the fabric and allow for the procedure to be carried out progressively. Typically, this is a polyester blend.<br/><br/><strong> Conclusion</strong><br/> Finally, we examined one of the most significant inventions of the recent decade: technical textiles. At first glance, it may appear to be just another material, but upon closer inspection, you&#39;ll notice that it has transformed many facets of our lives, from medicine hygiene goods to sporting apparel. <br/><br/><strong>About Sanathan Textiles </strong><br/>Sanathan Textiles is a polyester manufacturer and a global supplier of Cotton Yarns, Polyester Yarns and Yarns for Technical Textiles. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.",
    },
  ];

  const moreblogsArr = [
    {
      img: moreblog1,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog3,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
  ];

  const galleryArr = [
    {
      id: 1,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 2,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 3,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 4,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
  ];

  useEffect(() => {
    var gallery_swiper_container = new Swiper(
      ".swiper-container.gallery_swiper_container",
      {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: ".bloginner_sec2 .left_arrow",
          nextEl: ".bloginner_sec2 .right_arrow",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // centeredSlides: true,
        // loopedSlides: thumbArr.length, //how many slides it should duplicate
      }
    );
    var moreblogs_swiper_container = new Swiper(
      ".swiper-container.moreblogs_swiper_container",
      {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: false,
        navigation: {
          prevEl: ".bloginner_sec3 .left_arrow",
          nextEl: ".bloginner_sec3 .right_arrow",
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      }
    );
  });

  useEffect(() => {
    if (copied) {
      let copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied]);

  const dateList = blogDateArr.map((item) => (
    <>
      <p className="blog_date">{item.date} | </p>
      <p className="blog_category"> {item.category} </p>
      <p className="blog_company">| {item.company}</p>
    </>
  ));

  const descList = blogDescArr.map((item) => (
    <>
      <p
        className="blog_desc"
        dangerouslySetInnerHTML={{ __html: item.desc1 }}
      />
    </>
  ));

  const galleryVideoImageList = galleryArr.length
    ? galleryArr.map((item, i) => (
        <div className="swiper-slide" key={i}>
          {item.type == "video" ? (
            <>
              <div
                className="video_wrapper_div"
                onClick={() => handleImageWrapperClick(item.ytLink)}
              >
                <div className="content">
                  <img
                    src={item.image}
                    alt="Sanathan video gallery img"
                    loading="lazy"
                    className="gallery_img"
                  />
                  <div className="content-overlay"></div>
                  <img
                    src={playicon}
                    alt="Sanathan coloredArrow img"
                    loading="lazy"
                    className="playicon"
                    onClick={() => handleImageWrapperClick(item.ytLink)}
                  />
                  {/* <h2 className="galleryImageName">{item.title}</h2> */}
                </div>

                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          ) : (
            <>
              <div className="content">
                <img
                  src={item.image}
                  alt="Sanathan blog gallery img"
                  loading="lazy"
                  className="gallery_img"
                />
                <div className="content-overlay"></div>
                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          )}
        </div>
      ))
    : null;

  const moreblogsList = moreblogsArr.map((item, i) => (
    <>
      <li className="swiper-slide moreblog_detail_wrapper">
        <Link to="/blog-inner" key={i}>
          <div className="imageanimate zoom-out">
            <img
              src={item.img}
              alt="Sanathan our blog img"
              loading="lazy"
              className="moreblog_img"
            />
            {/* <div className="content-overlay"></div> */}
          </div>
          <div className="text_container">
            <h1 className="moreblog_date">{item.date}</h1>
            <div className="verticle_line"> | </div>
            <h1 className="moreblog_category"> {item.category}</h1>
            <h1 className="moreblog_name">{item.title}</h1>
            <p className="moreblog_synopsis">
              {reduceDescSize(item.desc, 100)}
            </p>
            <div className="moreblog_cta_wrapper"></div>
          </div>
        </Link>
      </li>
    </>
  ));

  const handleImageWrapperClick = (videoLink) => {
    setToggler(!toggler);
    setVidLink(videoLink);
  };

  const copyUrl = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/blogs/technical-textiles"
        metaTitle="Examples Of Technical Textiles | Sanathan Textiles"
        metaDesc=" Technical textiles in India are a vital component of modern life. This article will provide an overview of technical textiles, their examples and how it is used nowadays."
      />
      {/* <Banner
        imgSrc="https://via.placeholder.com/1920x300"
        breadcrumbWord1="Home"
        breadcrumbWord3="Blogs"
        breadcrumbWord4={blogDescArr[0].heading}
        link3="blogs"
        disabled
      /> */}
      <section className="bloginner_sec1" data-aos="fade-in">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blog Inner</div> */}
          {/* <div className="blog_heading">
            Blog Heading will come here lorem ipsum lorem ipsum example text
            here
          </div> */}
          <img
            className="mainimg"
            src={bannerInner3}
            alt="Sanathan blog inner img"
          />
          <div className="row social_icon_date">
            <div className="col-md-6 col-lg-4 datecat_list">
              {/* {dateList} */}
            </div>
            <div className="col-md-1 col-lg-4"></div>
            <div className="col-md-5 col-lg-4">
              {width < 767 ? <h2 className="share_title">Share</h2> : null}
              <div className="social_main_wrapper">
                <ul className="social_icons">
                  {width > 767 ? (
                    <li className="social_icon_li">
                      <h2 className="share_title">Share</h2>
                    </li>
                  ) : null}
                  <li className="social_icon_li">
                    <FacebookShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={facebook}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </FacebookShareButton>
                  </li>
                  <li className="social_icon_li">
                    <WhatsappShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={whatsapp}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </WhatsappShareButton>
                  </li>
                  <li className="social_icon_li">
                    <TwitterShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={twitterblog}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </TwitterShareButton>
                  </li>
                  <li
                    className="social_icon_li social_icon_li_copy"
                    onClick={copyUrl}
                  >
                    <span className="social_icon">
                      <img
                        src={copy}
                        alt="Sanathan copy url logo"
                        loading="lazy"
                      />
                    </span>
                    <span className="social_name">
                      {!copied ? "" : "Copied!"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="horizontal_line"></div>
          <h1 className="blog_inner_name">
            What Are Some Examples Of Technical Textiles?
          </h1>
          <div className="blog_desc">
            <p>
              Technical textiles in India are a vital component of modern life.
              These materials are employed in a wide range of industries, from
              medical gadgets to athletic products. This article will provide an
              overview of{" "}
              <a href="/products/yarn-for-technical-textile">
                technical textiles
              </a>
              , their examples and how it is used nowadays.
              <br />
              <br />
              First, Let’s understand what is Technical Textile? <br />
              <br />
              <strong> What Are Technical Textiles?</strong>
              <br />
              Technical textiles, also known as smart textiles are textile
              components and products with technical traits and characteristics.
              It is a textile product manufactured for non-aesthetic purposes,
              where the function is the primary criterion. They are created from
              natural and man-made fibres such as Nomex, Kevlar, Spandex, and
              Twaron, which have better functional features such as higher
              tenacity, excellent insulation, improved thermal resistance, and
              so on.
              <br />
              <br /> Technical textiles are a promising position in the textile
              industry. It is employed for the proper application of its
              functional features and the production of diverse applications.{" "}
              <br />
              <br />
              <strong>9 Technical Textiles Examples:</strong>
              <br /> <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong>1. Agrotextiles (Agro-Textiles)</strong>
              <br />
              Technical textile applications in agriculture cover all tasks
              related to the cultivation and harvesting of crops and animals.
              The primary role of most agricultural textiles is to protect food,
              animals, or land. Crop production, forestry and horticulture,
              livestock and poultry husbandry, and fishing are all examples of
              end uses. The fishing industry consumes a lot of textile
              materials. Fishing practices are becoming increasingly
              industrialized, with small net and line fishing techniques being
              phased out.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong> 2. Geotextiles (Geo-Textiles)</strong>
              <br /> Geotextiles are all woven, nonwoven, and knitted textile
              materials used primarily by the civil engineering sector to
              provide support, drainage, and isolation at or below ground level.
              Geotextiles are used in a variety of applications, including
              building, bridge, dam, road, railway, and path construction, as
              well as embankments, cuttings, dykes, and sub- sea coastal
              engineering projects. These are increasingly being used for waste
              containment in hazardous waste disposal sites and industrial and
              municipal effluent treatment facilities.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong> 3. Hometech (Domestic Textiles)</strong>
              <br /> Hometech is the fourth-largest seller of technical textiles
              in the world. Hometech products contain both synthetic and natural
              fibres. Western countries account for the biggest market share of
              hometech textiles followed by the Asia Pacific region. Hometech
              textiles are majorly used in furniture &amp; interior decoration,
              sun protection, cushion materials, carpeting, fireproofing, wall
              coverings, flooring and textile reinforced fittings etc. The
              hometech textiles market is supposed to observe a great increase
              of 4.8% CAGR year on year.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <strong>4. Indutech (Industrial Textiles)</strong>
              <br /> Indutech refers to textiles used in several industrial
              applications. There is increasing demand from uses like cleansing,
              conveyancing industrial instrumentation, agriculture and farming,
              environmental protection, sport and leisure, unit furnishing and
              coverings, and packaging. Technical textiles are proving their
              worth in yet another field, contributing to the advancement of
              industrial and technological growth. Technical textiles include
              mechanical and textile engineering goods and solutions. Indutech
              Textiles Market size is growing at a moderate pace with
              substantial growth rates over the last few years. It estimated
              that the market will grow significantly in the period from 2021 to
              2028.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <strong>5. Medtech (Medical Textiles) </strong>
              <br />
              The word MedTech refers to technical textiles used in the medical
              and rehabilitation industries. It entails the development,
              processing, and application of safe and sanitary products. Medical
              textiles from the MedTech sector help patients get the best care
              possible. Because of their high process dependability
              requirements, MedTech products are among the most advanced
              technical textiles. Textiles materials that are used in medical
              applications include fibres, yarns, fabrics and composites.
              Depending upon the application, the major requirements of medical
              textiles are absorbency, tenacity, flexibility, softness and at
              times biostability or biodegradability.
              <br />
              <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong> 6. Mobiltech (Textiles Used In Transport)</strong>
              <br /> Mobiltech textiles are utilised in the automotive and
              transportation industries. It&#39;s some sort of technological
              fabric. Some of the uses are automobiles, automotive components,
              aircraft and railways. Mobiltech is concerned with more than just
              isolation and safety; it is also concerned with comfort and
              aesthetics. Mobiltech is used in seatbelt webbing, car upholstery,
              airbags, helmets and tyre cords. Materials like nylon, polyester
              and polyester blends are used extensively in mobiltech.
              <br />
              <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              <strong>7. Ecotech (Eco-Friendly Textiles) </strong>
              <br />
              Oekotech or Ecotech is a textile application in environmental
              protection. It includes floor sealants, erosion protection, air
              cleaning, water pollution prevention, water cleaning, waste
              treatment/recycling, depositing area construction, product
              extraction, and household water sewerage plant. The key component
              in this is landfill waste management and the secondary protection
              is the chemical/oil industries. <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong>8. Protech (Protective Textiles)</strong>
              <br />
              Protective textile is a type of technical cloth that has
              exceptional protective properties to protect against a wide range
              of natural and man-made threats. It occasionally has smart
              e-textile features like chemical, heat and cold protection, and so
              on are all examples of protective functioning. Protective textiles
              has important use cases in frie suits, chemical clothing,
              biological suits, and ballistic vests. In most cases we can find
              it in bullet proof vests as well as space suits.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong> 9. SportTech (Sports Textiles)</strong>
              <br /> Sports textiles, also known as Sporttex, are primarily
              utilised in the production of sportswear, such as sports shoes and
              other sports equipment. The growing popularity of active sports
              and outdoor leisure activities such as flying, sailing, climbing,
              and cycling has resulted in a massive increase in the use of
              textile materials in the production of sporting and related items
              and equipment. In the production of athletic textiles, synthetic
              fibres and coatings have essentially supplanted conventional
              cotton fabrics and other natural fibres.
              <br />
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong> 10. Clothtech (Clothing Textiles)</strong> <br />
              Clothtech is a technical textile subset that includes all textile
              materials used in garments, footwear, laces, interlinings, zip
              fasteners, elastic narrow fabrics (tapes), Velcro, labels,
              umbrella cloth, and sewing threads. Technical textiles for
              clothing, particularly in the finishing process, where the fabric
              is handled under high pressure and high temperatures, support the
              fabric and allow for the procedure to be carried out
              progressively. Typically, this is a polyester blend.
              <br />
              <br />
              <strong> Conclusion</strong>
              <br /> Finally, we examined one of the most significant inventions
              of the recent decade: technical textiles. At first glance, it may
              appear to be just another material, but upon closer inspection,
              you&#39;ll notice that it has transformed many facets of our
              lives, from medicine hygiene goods to sporting apparel. <br />
              <br />
              <strong>About Sanathan Textiles </strong>
              <br />
              Sanathan Textiles is a{" "}
              <a href="/products/polyester-yarn">
                {" "}
                polyester manufacturer{" "}
              </a>{" "}
              and a global supplier of{" "}
              <a href="/products/cotton-yarn">Cotton Yarns </a>, Polyester Yarns
              and Yarns for Technical Textiles. With 3 yarn business verticals,
              we offer a wide variety of yarns that are used by various sectors
              and industries, across applications and end-uses. Technologically
              advanced and environmentally conscious manufacturing setup enables
              us to offer customers value-added yarns, niche yarns, functional
              yarns and a wide range of coloured yarns. Sanathan Textiles is
              committed to providing Value added Innovative Yarns for the Fabric
              of our Lives.
            </p>
          </div>

          {/* <div>{descList}</div> */}
        </div>
      </section>

      {/* {galleryVideoImageList && (
        <section className="bloginner_sec2" data-aos="fade-up">
          <div className="wrapper">
            <div className="heading_arrow_flex">
              <div className="gallery_heading">Gallery</div>
              {width > 767 ? (
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              ) : null}
            </div>
            <div className="gallery_slider_wrapper">
              <div className="swiper-container gallery_swiper_container">
                <div className="swiper-wrapper">{galleryVideoImageList}</div>
              </div>
              {width < 767 ? (
                <div className="arrows_wrapper">
                  <div className="navigations">
                    <button className="left_arrow">Previous</button>
                    <button className="right_arrow">Next</button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      )} */}

      {/* <section className="bloginner_sec3" data-aos="fade-up">
        <div className="horizontal_line"></div>
        <div className="wrapper">
          <div className="heading_arrow_flex2">
            <h2 className="moreblog_heading">More Blogs</h2>
            {width > 767 ? (
              <div className="navigations">
                <button className="left_arrow">Previous</button>
                <button className="right_arrow">Next</button>
              </div>
            ) : null}
          </div>

          <div className="moreblogs_wrapper">
            <div className="swiper-container moreblogs_swiper_container">
              <ul className="swiper-wrapper moreblogs_swiper_wrapper">
                {moreblogsList}
              </ul>
            </div>
            {width < 767 ? (
              <div className="arrows_wrapper">
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section> */}
      {/* <FsLightbox toggler={toggler} sources={[vidLink]} /> */}
    </>
  );
};

export default BlogInner;
